import { gaEventNoHit } from "../shared/helpers/gtm_tracking";

import { setTitle, resetModal } from "../utils/Enquiries";
import initForm from "../utils/Forms";

const handleEnquiryClick = buttonSelector => e => {
  if (e.target.closest(buttonSelector)) {
    $("#js-digital-brochure-request-modal").modal("hide");
    $('#js-digital-brochure-request-modal').on('hidden.bs.modal', function () {
      $("#js-general-enquiry-modal").modal("show");
    });
  }
};

const setFormAttributes = (form, data) => {
  const { brochureType, brochurePath, gtmCategory, gtmAction } = data;
  const brochureTypeField = form.querySelector(".js-brochure-type");
  const brochurePathField = form.querySelector(".js-brochure-path");
  const contactLink = form.querySelector(".js-contact-link");
  const downloadButton = form.querySelector(".js-brochure-download-button");

  Object.assign(form.dataset, {
    brochurePath,
    brochureType,
    gtmCategory,
    gtmAction
  });

  if (brochureTypeField) {
    brochureTypeField.value = brochureType;
  }

  if (brochurePathField) {
    brochurePathField.value = brochurePath;
  }

  if (contactLink) {
    contactLink.dataset.gtmCategory = data.contactLinkGtmCategory;
  }

  if (downloadButton) {
    Object.assign(downloadButton.dataset, {
      gtmCategory,
      gtmAction,
      gtmLabel: "Brochure"
    });
  }
};

const handleClick = buttonSelector => e => {
  if (!e.target.closest(buttonSelector)) {
    return;
  }

  const data = e.target.dataset;
  const modal = document.querySelector(data.targetModalId);
  const brochureForm = modal
    ? modal.querySelector(".js-digital-brochure-request-form, .js-print-brochure-request-form")
    : null;

  if (!modal || !brochureForm) {
    return;
  }

  setTitle(brochureForm, data.brochureTitle);
  setFormAttributes(brochureForm, data);

  $(modal).modal("show");
};

const handlePrintBrochureFormSubmit = e => {
  e.preventDefault();

  const form = e.target;
  const { gtmCategory, gtmAction } = form.dataset;
  const brochureType = {
    name: "brochure_request[brochure_type]",
    value: form.dataset.brochureType
  };
  const brochure = form.closest(".js-brochure");
  const submit = form.querySelector("button[type='submit']");
  const firstName = form.querySelector("input[name='brochure_request[first_name]']").value;
  const firstNameTitle = firstName.charAt(0).toUpperCase() + firstName.slice(1);

  $
    .post(form.action, $(form).serializeArray().concat(brochureType))
    .done(() => {
      gaEventNoHit(gtmCategory, gtmAction, "Brochure");
      brochure.classList.remove("has-failed");
      brochure.classList.add("has-succeeded");
      form.querySelector(".js-first-name").innerHTML = firstNameTitle;
    })
    .fail(() => {
      brochure.classList.add("has-failed");
    })
    .always(() => {
      submit.removeAttribute("disabled");
    });
};

const initPrintBrochureTogglePhoneConsent = e => {
  const checkbox = e.querySelector("#brochure_request_phone_opt_in");

  checkbox.addEventListener("click", function () {
    const phoneField = e.querySelector(".js-phone-consent");

    phoneField.querySelector(".js-phone-input").required = this.checked;
    phoneField.classList.toggle("hide");
  });
};

const initBrochureRequestForms = () => {
  Array
    .from(document.querySelectorAll(".js-print-brochure-request-form"))
    .forEach(form => {
      initForm(form, { submit: handlePrintBrochureFormSubmit });
    });

  Array
    .from(document.querySelectorAll(".js-brochure"))
    .forEach(brochure => resetModal(brochure));

  initPrintBrochureTogglePhoneConsent(document.querySelector(".js-print-brochure-request-form"));
  document.body.addEventListener("click", handleClick(".js-brochure-button"));
  document.body.addEventListener("click", handleEnquiryClick(".js-digital-brochure-enquiry"));
};

export default initBrochureRequestForms;



// WEBPACK FOOTER //
// ./components/brochure.js